
const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const getDeskByIdApi = async (deskId) => {
    const token = localStorage.getItem('token');
    try {
        const response = await fetch(
            `${API_BASE_URL}/admin/user/desks/${deskId}`,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            }
        );

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData?.message || `Ошибка при загрузке деска с ID ${deskId}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error(`Ошибка при получении деска с ID ${deskId}:`, error);
        throw error;
    }
};